import ReduxTypes from '../consts/ReduxTypes';

const initialState = {
  loading: false,
  error: null,
  stats: null,
  downloadCsvLoading: false,
  downloadCsvError: null,
  downloadCsvBlob: null,
};

export default function statisticsReducer(state = initialState, action: any) {
  switch (action.type) {
    case ReduxTypes.FETCH_STATISTICS_START:
      return { ...state, loading: true, error: null };
    case ReduxTypes.FETCH_STATISTICS_SUCCESS:
      return { ...state, loading: false, stats: action.payload };
    case ReduxTypes.FETCH_STATISTICS_ERROR:
      return { ...state, loading: false, error: action.error };
    case ReduxTypes.DOWNLOAD_STATISTICS_CSV_START:
      return { ...state, downloadCsvLoading: true, downloadCsvError: null };
    case ReduxTypes.DOWNLOAD_STATISTICS_CSV_SUCCESS:
      return { ...state, downloadCsvLoading: false, downloadCsvBlob: action.payload };
    case ReduxTypes.DOWNLOAD_STATISTICS_CSV_ERROR:
      return { ...state, downloadCsvLoading: false, downloadCsvError: action.error };
    default:
      return state;
  }
}
